/** Modale de règles pédagogiques + démos peintes « à résoudre → résolu » (index.html:1968-2011). */
import { systemRng } from '@ordre-cache/shared';
import { G, state } from '../state';
import { RULES } from '../rules-content';
import { hasSeen, markSeen } from '../storage';
import { deep } from '../engines/util';

/** Peint le même puzzle-exemple non résolu (gauche) puis résolu (droite). */
function drawDemos(): void {
  const g = G();
  const c1 = document.getElementById('ruC1') as HTMLCanvasElement | null;
  const c2 = document.getElementById('ruC2') as HTMLCanvasElement | null;
  if (!c1 || !c2) return;
  try {
    g.resetSel?.();
    const demo = g.gen(0, g.sizes[0], 0, systemRng); // petit exemple, défi 1, facile
    const paint = (cnv: HTMLCanvasElement, solved: boolean): void => {
      const p = deep(demo);
      if (solved) g.solveIt(p);
      const S = 132;
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      cnv.width = Math.round(S * dpr);
      cnv.height = Math.round(S * dpr);
      const ctx = cnv.getContext('2d');
      if (!ctx) return;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      g.draw(p, ctx, { size: S });
    };
    paint(c1, false);
    paint(c2, true);
  } catch {
    /* démo best-effort — ne bloque jamais l'ouverture des règles */
  }
}

export function openRules(): void {
  const g = G();
  const r = RULES[g.id];
  const setHtml = (id: string, html: string): void => {
    const el = document.getElementById(id);
    if (el) el.innerHTML = html;
  };
  setHtml('ruH', `${g.icon} ${g.name}`);
  const tag = document.getElementById('ruTag');
  if (tag) tag.textContent = g.tag;
  let h = '';
  h += `<h3>🎯 Le but</h3><p>${r.but}</p>`;
  h += `<h3>👆 Les gestes</h3><ul>${r.gestes.map((x) => `<li>${x}</li>`).join('')}</ul>`;
  h += `<h3>🎨 Ce que tu vois</h3><ul>${r.legende.map((x) => `<li>${x}</li>`).join('')}</ul>`;
  h += `<h3>💡 Astuce</h3><p>${r.astuce}</p>`;
  setHtml('ruBody', h);
  const d = g.defis[state.defi];
  setHtml('ruDefi', `<b>${d.ic ?? '🎯'} Ton défi ${state.defi + 1}/6 — ${d.n}</b><br>${d.d}`);
  document.getElementById('rulesModal')?.classList.remove('hidden');
  drawDemos();
}

export function closeRules(): void {
  document.getElementById('rulesModal')?.classList.add('hidden');
}

/** Ouvre les règles à la première visite d'un jeu (index.html:2006-2011). */
export function maybeAutoRules(): void {
  const g = G();
  if (hasSeen(g.id)) return;
  markSeen(g.id);
  openRules();
}
